// Repository layer responsible for API / data source communication
import featureFlagsRepository from '../repositories/featureFlagsRepository';

// Service layer acts as an abstraction between UI and repository
// Useful for adding business logic, transformations, or caching later
const featureFlagsService = {
  /**
   * Fetches feature flags for a given SyncUp application
   *
   * @param {Object} params
   * @param {string} params.syncUpAppName - Name of the SyncUp application
   * @returns {Promise<Array>} List of feature flags
   */
  getFeatureFlags: async ({ syncUpAppName }) => {
    return await featureFlagsRepository.getFeatureFlags({ syncUpAppName });
  }
};

export default featureFlagsService;
